import { useState, useEffect, useCallback } from 'react';
import api from '../../api';
import Layout from '../../components/Layout';
import stili from '../../components/competenze/stili';
import ConflittoVersione, { eConflitto } from '../../components/ConflittoVersione';

// Impostazioni Competenze (solo admin): codice IVA di GIS per ciascun fatturante
export default function Impostazioni() {
  const [fatturanti, setFatturanti] = useState([]);
  const [modifiche, setModifiche] = useState({});
  const [messaggio, setMessaggio] = useState('');
  const [errore, setErrore] = useState('');
  const [conflitto, setConflitto] = useState(null);

  const carica = useCallback(() => {
    api.get('/competenze/fatturanti').then(r => {
      setFatturanti(r.data);
      setModifiche(Object.fromEntries(r.data.map(f => [f.id, { codice_iva_gis: f.codice_iva_gis || '', note: f.note || '', version: f.version }])));
    }).catch(() => {});
  }, []);
  useEffect(() => { carica(); }, [carica]);

  const salva = async (f, version) => {
    setErrore('');
    setMessaggio('');
    try {
      await api.put(`/competenze/fatturanti/${f.id}`, { ...modifiche[f.id], version });
      setConflitto(null);
      setMessaggio(`Salvato ${f.nome}`);
      carica();
    } catch (err) {
      if (eConflitto(err)) setConflitto({ ...err.response.data, fatturante: f });
      else setErrore(err.response?.data?.errore || 'Salvataggio non riuscito');
    }
  };

  const aggiorna = (id, campo, valore) => setModifiche(m => ({ ...m, [id]: { ...m[id], [campo]: valore } }));

  return (
    <Layout>
      <h2 style={{ marginTop: 0 }}>Impostazioni Parcellazione</h2>
      <p style={{ color: '#555' }}>
        Codice GIS del fatturante e codice IVA GIS del fatturante (PARMOV-CIVA), da usare nel file per GIS. Marco e Giacomo sono forfettari (nessuna IVA),
        McMirrors e Gianfranco applicano il 22%: inserisci i codici così come sono configurati in GIS.
      </p>
      {errore && <div style={stili.errore}>{errore}</div>}
      {messaggio && <div style={{ ...stili.errore, background: '#ecfdf5', color: '#166534' }}>{messaggio}</div>}
      <div style={{ overflowX: 'auto' }}>
      <table style={stili.table}>
        <thead>
          <tr>
            <th style={stili.th}>Fatturante</th>
            <th style={stili.th}>Codice GIS del fatturante</th>
            <th style={stili.th}>Codice IVA GIS del fatturante</th>
            <th style={stili.th}>Note</th>
            <th style={stili.th}></th>
          </tr>
        </thead>
        <tbody>
          {fatturanti.map(f => (
            <tr key={f.id} style={stili.tr}>
              <td style={stili.td}>{f.nome}</td>
              <td style={stili.td}>{f.codice_azienda_gis}</td>
              <td style={stili.td}>
                <input value={modifiche[f.id]?.codice_iva_gis || ''} maxLength={10} onChange={e => aggiorna(f.id, 'codice_iva_gis', e.target.value)}
                  style={{ ...stili.input, width: '110px' }} placeholder="da compilare" aria-label={`Codice IVA GIS del fatturante ${f.nome}`} />
              </td>
              <td style={stili.td}>
                <input value={modifiche[f.id]?.note || ''} onChange={e => aggiorna(f.id, 'note', e.target.value)} style={stili.input} aria-label={`Note ${f.nome}`} />
              </td>
              <td style={stili.td}><button onClick={() => salva(f, modifiche[f.id]?.version)} style={stili.btnSmall}>Salva</button></td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
      {conflitto && (
        <ConflittoVersione
          conflitto={conflitto}
          onRicarica={() => { setConflitto(null); carica(); }}
          onSovrascrivi={() => salva(conflitto.fatturante, conflitto.attuale.version)}
        />
      )}
    </Layout>
  );
}
